import { Box } from "@mui/material";
import React from "react";

export default function RootScreen({ children }) {
  return <Box sx={{ display: "flex", flexGrow: 1 }}>{children}</Box>;
}
